module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"You have not defined any impacts yet. Get started now!"},"de":{"empty":"Du hast noch keine Wirkungen definiert. Leg jetzt los!"}}')
  delete Component.options._Ctor
}
